@defer (when hasLoaded()) {
  @if (!isEnabled()) {
    <app-info-panel state="warning">Issue tracking not enabled</app-info-panel>
  } @else {
    <section class="stats">
      <app-issue-tracking-stats />
    </section>
    <div class="search">
      <app-search-input [searchText]="searchInputText()" [resultCount]="searchInputCount()" (onSearchChanged)="searchChanged($event)" tooltipText="Search Issues"></app-search-input>
    </div>
    <app-toolbar size="small">
      <div class="right">
        <app-button size="small" icon="mdi mdi-rotate-3d-variant" [label]="showComments() ? 'Showing last comment' : 'Showing details'" [title]="showComments() ? 'Click to show details' : 'Click to show last comment'" (click)="toggleCommentState()" tooltipPosition="left" />
        <app-button size="small" icon="mdi mdi-rotate-3d-variant" [label]="toggles.state" (click)="toggleState()" />
        <app-button size="small" icon="mdi mdi-download" label="Export" (click)="exportClick()" />
      </div>
    </app-toolbar>

    @if (dataTable()) {
      <app-data-table [dataTable]="dataTable()" (onRowClick)="rowClick($event)" [canFilterByAssetType]="false" dataTableKey="issuetracking:list" [actions]="[{ type: 'update' }]" (onActionClick)="actionClick($event)" />
    } @else {
      @if (issues()) {
        <app-info-panel>No outstanding issues for selection. </app-info-panel>
      }
    }
  }
} @placeholder {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}

@switch (dialog()) {
  @case ('update') {
    <app-dialog [canScroll]="false" (onClose)="dialog.set(null)" [dimensions]="{ width: 880, height: 460 }" header="Update Issue">
      <app-issue-tracking-update [issueId]="issueId()" (onUpdated)="issueUpdated($event)" (onCompleted)="issueCompleted($event)" />
    </app-dialog>
  }
  @case ('export') {
    <app-dialog header="Export Data" [canScroll]="false" (onClose)="dialog.set(null)" [dimensions]="{ width: 880, height: 460 }">
      <app-issue-tracking-export (onExport)="startExport($event)" />
    </app-dialog>
  }
}
